module.exports = __webpack_public_path__ + "static/media/logo_swieta.373e3dd5.png";